// Mounts the platform-provided user-list route at /admin/users.
//
// Sits under the admin shell (per __root.tsx's URL-prefix switch).
// `staticData.nav` registers the entry in the AppShell sidebar via
// the auto-derived Navigation component.

import { userListRoute } from '@podium/platform/routes'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/users/')({
  ...userListRoute,
  staticData: {
    nav: { label: 'Users', order: 20, group: 'Admin' },
    breadcrumb: 'Users',
  },
})
